/* CTA loader: spinner on the clicked Add to Cart / Buy Now button. Styles: assets/cta-loader.css */
(function() {
  if (window.CtaLoader) return;

  const ADD = 'form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] button[name="add"]';
  const BUY = '#gokwik-buy-now, [data-card-buy-now]';

  /* Shows the spinner for ms, or until the returned stop() is called */
  function start(btn, ms) {
    if (!btn || btn.classList.contains('is-cta-loading')) return function() {};
    btn.classList.add('is-cta-loading');
    const stop = function() { btn.classList.remove('is-cta-loading'); };
    setTimeout(stop, ms);
    return stop;
  }

  function startAdd(btn) {
    return start(btn, 1000);
  }

  /* Buy Now: spinner until the GoKwik checkout popup is on screen */
  function startBuy(btn) {
    const stop = start(btn, 12000);
    const watch = setInterval(function() {
      const frame = document.getElementById('gokwik-iframe');
      if (frame && frame.offsetParent) {
        clearInterval(watch);
        stop();
      }
    }, 150);
    setTimeout(function() { clearInterval(watch); }, 12000);
    return stop;
  }

  /* Cards whose product has options open the quick view popup (card-quick-view.js) instead of adding */
  function opensPopup(btn, form) {
    if (!(window.cardQuickViewConfig || {}).quickView) return false;
    if (btn.hasAttribute('data-card-buy-now')) return !!btn.dataset.quickView;
    return !!(form && form.dataset.quickView && !form.dataset.cqvBypass);
  }

  /* Window capture: other scripts (cart trackers, GoKwik) stop the click before it reaches the document */
  window.addEventListener('click', function(event) {
    const target = event.target;
    if (!target || !target.closest) return;

    const buy = target.closest(BUY);
    if (buy) {
      if (!buy.disabled && !opensPopup(buy)) startBuy(buy);
      return;
    }

    const add = target.closest(ADD);
    /* <product-form> (quick add drawer) has the theme's own spinner */
    if (!add || add.disabled || add.closest('product-form') || opensPopup(add, add.closest('form'))) return;
    startAdd(add);
  }, true);

  /* Back button restores the page from cache: clear any spinner left on */
  window.addEventListener('pageshow', function(event) {
    if (!event.persisted) return;
    document.querySelectorAll('.is-cta-loading').forEach(function(el) { el.classList.remove('is-cta-loading'); });
  });

  window.CtaLoader = { start: start, startAdd: startAdd, startBuy: startBuy };
})();
